module.exports = __webpack_public_path__ + "media/images/countrysquared/ad-8f611c172a07141d166859c83d6748a4.svg";